import HTML from '../../src/images/techstack/html.png';
import CSS from '../../src/images/techstack/css.png';
import JS from '../../src/images/techstack/js.png';
import ReactJS from '../../src/images/techstack/react.png';
import Redux from '../../src/images/techstack/redux.png';
import Mui from '../../src/images/techstack/mui.png';
import Mongo from '../../src/images/techstack/mongo.png';
import Node from '../../src/images/techstack/node.png';
import Python from '../../src/images/techstack/python.png';
import Figma from '../../src/images/techstack/figma.png';
import Image from '../../src/images/projects/HM.webp';
import Webbedout from '../../src/images/projects/webbedout.webp';
import Kalasad from '../../src/images/projects/kalasad.webp';
import Portfolio from '../../src/images/projects/portfolio.webp';
import Crypto from '../../src/images/projects/crypto.webp';
import Eagr from '../../src/images/projects/eagr.webp';
import CUBE2 from '../../src/images/projects/cube2.webp';
import CUBE from '../../src/images/projects/cube.webp';
import Vithub from '../../src/images/projects/vithub.webp';
import WeCare from '../../src/images/projects/wecare.webp';
import BarRaiser from '../../src/images/work/barraiser.jpg';
import MMT from '../../src/images/work/MMT.png';
import Czar from '../../src/images/work/czar.jpg';
import TSP from '../../src/images/work/TSP.png';
import WebbedoutLogo from '../../src/images/work/webbedout.jpg';

const content = {
  experiences: [
    {
      name: 'MakeMyTrip',
      role: 'Software Engineer',
      span: 'July 2022 - Present',
      link: 'https://www.makemytrip.com/',
      image: MMT,
      tag: 'FULL-TIME',
      description: {
        first: "MakeMyTrip is India's No. 1 online travel website started in the year 2000.",
        second:
          ' Working with the frontend team of Where2Go (App + Web) for creating wonderful user experiences using React Native.',
      },
    },
    {
      name: 'MakeMyTrip',
      role: 'Software Engineer Intern',
      span: 'January 2022 - June 2022',
      link: 'https://www.makemytrip.com/',
      image: MMT,
      tag: 'INTERNSHIP',
      description: {
        first: "MakeMyTrip is India's No. 1 online travel website started in the year 2000.",
        second:
          ' Working with the frontend team (App) for creating wonderful user experiences using React Native.',
      },
    },
    {
      name: 'WebbedOut',
      role: 'User Interface Developer',
      span: 'December 2021 - Present',
      link: 'https://webbedout.devus.org/',
      image: WebbedoutLogo,
      tag: 'FREELANCING',
      description: {
        first:
          'WebbedOut is a freelance service that helps you created websites for your business/personal needs.',
        second:
          'Working as a freelancer here who works on designing and coding the user interface!',
      },
    },
    {
      name: 'BarRaiser',
      role: 'Software Engineer Intern',
      span: 'July 2021 - November 2021',
      link: 'https://barraiser.com/in/home',
      image: BarRaiser,
      tag: 'INTERNSHIP',
      description: {
        first:
          'BarRaiser helps companies hire the right candidate for the job with a trusted, data-driven evaluation and save time, money, and effort.',
        second:
          ' Worked in integrating slack bot with internal Barraiser events using React, Spring Boot, GraphQL and AWS.',
      },
    },
    {
      name: 'Czarvision Technology',
      role: 'Jr SharePoint Developer Intern',
      span: 'February 2021 - April 2021',
      link: 'https://czarvision.com/',
      image: Czar,
      tag: 'INTERNSHIP',
      description: {
        first:
          'Czarvision is a startup based out of Pune that provides various kinds of IT solutions.',
        second:
          'Worked on building a timesheet application from scratch using Powerapps and SharePoint.',
      },
    },
    {
      name: 'The Sparks Foundation',
      role: 'Web Developer and Design Intern',
      span: 'March 2021 - April 2021',
      link: 'https://www.thesparksfoundationsingapore.org/',
      image: TSP,
      tag: 'INTERNSHIP',
      description: {
        first:
          'TSP is an Indian startup that works to bring parity in education, making sure children have equal opportunity at success.',
        second: 'Build a banking system  for customers from scratch using React, Node and Figma.',
      },
    },
  ],
  projects: [
    {
      image: Image,
      title: 'HM Jewellers',
      link: 'javascript:void(0)',
      description:
        'A desktop application made for a jewellery shop to create bills, keep track of customers bills, reminders, payments etc. Built with Electron, Node and Figma',
    },
    {
      image: Webbedout,
      title: 'WebbedOut',
      link: 'https://webbedout.devus.org/',
      description:
        'Official website of Webbedout freelancers. This is the landing page of Webbedout, which is one of the finest freelancing services organisation! DO TRY IT! Built with React, Node and designed in Figma',
    },
    {
      image: Kalasad,
      title: 'Kalasaad',
      link: 'https://www.kalasaadstudios.com/',
      description:
        'A landing page of an art exhibtion gallery. Includes payment gateway that helps customer purchase the paintings. Built with React and designed on Figma.',
    },
    {
      image: Portfolio,
      title: 'Portfolio',
      link: 'https://samarthnehe.netlify.app/',
      description:
        'Hehe, This is the website that you are currently on! My personal website built with React and designed on Figma by me.',
    },
    {
      image: Eagr,
      title: 'Eagr',
      link: 'https://eagr.netlify.app/blogs',
      description:
        'Eagr is a community of people who are on their journey of creating the best possible career for themselves.Built using ReactJS',
    },
    {
      image: Crypto,
      title: 'CryptO Roulette',
      link: 'https://hackulus-6d620.web.app/',
      description:
        'A hack winning project! (bucket list lol). Website that provides features like risk-authentication, malware detection, randomised encrypiton! Developed using React and Node. Designed in Figma',
    },
    {
      image: CUBE2,
      title: 'C.U.B.E VIT 2.0',
      link: 'https://cubevit-e1c09.web.app/',
      description:
        'By this time I had become an Ex, so as a developer I made the website that was designed by the current design head. Made with ReactJS',
    },
    {
      image: Vithub,
      title: 'VITHub',
      link: 'https://vit-hub.herokuapp.com/',
      description:
        'VITHUB is a question-answer website for students of VIT, where students can put their questions and seniors can answer them. Built with NodeJS.',
    },
    {
      image: CUBE,
      title: 'C.U.B.E VIT',
      link: 'https://cubevit.herokuapp.com/',
      description:
        'As a chairperson I took the initiative of designing and building a website for my club! Though it was not good! But yes I am proud of it..',
    },
  ],
  techstack: [
    {
      name: 'HTML',
      image: HTML,
    },
    {
      name: 'CSS',
      image: CSS,
    },
    {
      name: 'Javascript',
      image: JS,
    },
    {
      name: 'Material UI',
      image: Mui,
    },
    {
      name: 'React',
      image: ReactJS,
    },
    {
      name: 'Redux',
      image: Redux,
    },
    {
      name: 'Python',
      image: Python,
    },
    {
      name: 'Node',
      image: Node,
    },
    {
      name: 'Mongo DB',
      image: Mongo,
    },
    {
      name: 'Figma',
      image: Figma,
    },
  ],
  about: {
    first:
      "Hi I'm Samarth Nehe! I am a Software Engineer at MakeMyTrip. I have completed my B.Tech in Computer Science and Engineering from VIT Vellore with a CGPA of 8.98.",
    second:
      'I am primarily a frontend Web/App Developer and UI Designer! In the past 3 years I have worked with React, Node, MongoDB, GraphQl, Next, Figma and UI/UX. Getting my hands dirty over TypeScript and React Native. Not much into backend, but I am spending some time learning Java. Also I am well versed with Python.',
    third:
      'Apart from Academics I am also a Speedcuber that makes me mention myself as the Co-Founder and Former-Chairperson of C.U.B.E VIT. I like to sing, play guitar and sketch at times!',
  },
  intro: {
    text: "Firstly, thanks for landing here, much appreciated! Need not tell my name here, it's written up there in BIG fonts! Just a small introduction, I am a geek still trying to figure out what to do in life! which then makes me work with various types of webtechnologies and languges. SCROLL DOWN for more!",
  },
  researchPaper: {
    kicker: 'RESEARCH PAPER',
    heading: 'CryptO’Roulette - A Smart Approach To Modern Encryption',
    journal: 'International Journal of Engineering and Advanced Technology (IJEAT)',
    authors: [
      'Samarth Nehe',
      'Varun Mishra',
      'Atharva Gulhane',
      'P.G.V SaiKarthik',
      'Navyaa Sharma',
    ],
    link: 'https://www.ijeat.org/portfolio-item/b33111211221/',
  },
  ps: {
    header: 'PS.',
    text: 'Not only tech, but I am also interested to talk about Movies, Bollywood Music, Cubing and Life in general! If you are into any of these we are friends already!',
    thought:
      '" I believe that creative collaboration between technology and design is the magic that takes experience from good to great "',
  },
  medium: {
    header: 'MY BLOGS',
    text: 'When bored I spend some time reading and writing tech blogs. If you are into reading blogs, do read some of mine!',
  },
};

export default content;
